import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';

import type { NavMode } from './types';
import { MsgWrapper, StyledA } from './wrappers';

/**
 * NavMenu Props
 */
export interface NavMenuLinkProps {
  /** Callback on click */
  onClick?: () => void;
  /** If the link is getting rendered in NavBar of NavFullPage */
  mode?: NavMode;
  /** If the link is currently selected */
  selected?: boolean;
  /** The link */
  href: string;
  /** The message to display */
  message: MessageDescriptor;
}

/**
 * A nav menu link
 */
export function NavMenuLink({
  href,
  message,
  onClick,
  selected,
  mode,
  ...props
}: NavMenuLinkProps): JSX.Element {
  const { formatMessage } = useIntl();
  return (
    <StyledA
      href={href}
      selected={selected}
      onClick={onClick}
      mode={mode}
      {...props}
    >
      <MsgWrapper selected={selected} mode={mode}>
        {formatMessage(message)}
      </MsgWrapper>
    </StyledA>
  );
}
